





































































import Vue from "vue";
import Component from "vue-class-component";
import PaginateModel from "@/model/paginate";
import { FinancialManagerService, FinancialFinancialDTO } from "@/common/api";
import EditFinancial from "@/pages/zaimu/edit.vue";
import QTableHeader from "@/common/qTableHeader.vue";
import QPaginate from "@/common/qPaginate.vue";
import qNotify from "@/common/qNotify";
import { AwsService as awsApi } from "@/common/api/services/AwsService";

@Component({
  name: "ZaimuIndex",
  components: {
    QTableHeader,
    QPaginate,
    EditFinancial,
  },
})
export default class ZaimuIndex extends Vue {
  public initSearch = {
    sort: "created_at",
    direction: "desc",
    perPage: 20,
    currentPage: 1,
  };
  public pagination = new PaginateModel({
    page: 0,
    pageCount: 0,
    start: 0,
    end: 0,
    count: 0,
  });

  public initHeaders = [
    { id: "created_at", name: "登録日", order: "desc" },
    { id: "year", name: "期", order: "" },
    { id: "type", name: "書類名" },
    { id: "file", name: "PDF" },
    { id: "", name: "" },
  ];

  public headers = [];

  public editIndex = null;

  public financialList: FinancialFinancialDTO[] = [];

  mounted() {
    this.headers = JSON.parse(JSON.stringify(this.initHeaders));
    this.filter();
  }

  public filter(): void {
    let query = this.$router.currentRoute.query;
    this.doSearch(query);
  }

  public doSearch(query: any = {}): void {
    query = {
      ...this.initSearch,
      ...query,
    };
    this.getList(query);
    this.$el.querySelector(".mb__responsive-table").scrollTop = 0;
  }

  public async getList(query) {
    const result = await FinancialManagerService.financial(query);
    this.pagination = new PaginateModel({
      page: result.data.paginator.currentPage,
      pageCount: result.data.paginator.lastPages,
      start: result.data.paginator.currentPage,
      end: result.data.paginator.lastPages,
      count: result.data.paginator.total,
    });
    this.financialList = result.data.financialList;
  }

  public addFinancial() {
    (this.$refs.editFinancial as EditFinancial).show();
  }

  public editFinancial(financial) {
    (this.$refs.editFinancial as EditFinancial).show(financial);
  }

  public clear() {
    this.headers = JSON.parse(JSON.stringify(this.initHeaders));
    this.$router.replace({ query: {} });
    this.doSearch();
  }

  async showFile(file) {
    try {
      const result = await awsApi.awsDownloadFilePresign({
        filePath: file.name,
      });

      fetch(result.data.presign.url, { method: "GET" })
        .then((response) => {
          return response.blob();
        })
        .then((blob) => {
          var url = window.URL.createObjectURL(blob);
          window.open(url);
        });
    } catch (error) {
      qNotify.error({
        text: error.message,
      });
    }
  }
}
